<template>
    <v-card class="material-dialog">
        <v-card-title class="text-h5 card-text">
            Optical Path
        </v-card-title>

        <v-card-text class="card-text">
            Το Optical Path όπως προκύπτει από το αρχείο της Προδέσμευσης
        </v-card-text>
        <array-view  :items="opticalPath" :headers="headers" :totalPages="0" :page="1" :size="10" />
    </v-card>
</template>

<script>
    import ArrayView from '@/components/ArrayView.vue'

    export default {
        components: { ArrayView },
        props: {
            opticalPath: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                headers: [
                    {
                        text: 'Optical Path Type',
                        align: 'start',
                        sortable: false,
                        value: 'opticalPathType'
                    },
                    { text: 'Optical Path', value: 'opticalPath' },
                    { text: 'GISID', value: 'gisid' }
                ]
            }
        },
        methods: {

        }
    }
</script>
<style scoped>

.card-text {
    color: var(--cards-and-tables-text-color) !important;
}

</style>
